import { Component, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  imports: [TranslocoPipe],
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
